module.exports = __webpack_public_path__ + "d3df42da90c6a077c532fad041b2246e.svg";